import React from 'react';

export interface WorkflowSortField<Field extends string> {
  field: Field;
  label: string;
  defaultAscending: boolean;
}

interface WorkflowSortControlsProps<Field extends string> {
  fields: readonly WorkflowSortField<Field>[];
  value: Field;
  ascending: boolean;
  onChange: (field: Field, ascending: boolean) => void;
  ariaLabel: string;
  children?: React.ReactNode;
}

const WorkflowSortControls = <Field extends string,>({
  fields, value, ascending, onChange, ariaLabel, children,
}: WorkflowSortControlsProps<Field>) => (
  <div className="workflow-video-actions workflow-sort-controls" role="group" aria-label={ariaLabel}>
    {fields.map(({ field, label, defaultAscending }) => (
      <button type="button" key={field} className="workflows-refresh" aria-pressed={value === field}
        onClick={() => onChange(field, value === field ? !ascending : defaultAscending)}>
        {label} {value === field ? (ascending ? '↑' : '↓') : ''}
      </button>
    ))}
    {children}
  </div>
);

export default WorkflowSortControls;
